import { render, staticRenderFns } from "./DataAccessRestrictionsSettings.vue?vue&type=template&id=877c9bfe&"
import script from "./DataAccessRestrictionsSettings.vue?vue&type=script&lang=js&"
export * from "./DataAccessRestrictionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports